import { transport } from 'config/transport';

export function callApiExportSoThuThanhToan(congDoanId, classId, month, type, subjectIds = []) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu/exportSoThuThanhToan`, {
        params: { month, type, subjectIds: subjectIds.join(',') },
        responseType: 'blob',
    });
}
